import { render, staticRenderFns } from "./companyMsg.vue?vue&type=template&id=212d8f13&scoped=true&"
import script from "./companyMsg.vue?vue&type=script&lang=js&"
export * from "./companyMsg.vue?vue&type=script&lang=js&"
import style0 from "./companyMsg.vue?vue&type=style&index=0&id=212d8f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d8f13",
  null
  
)

export default component.exports